import { atom, useRecoilValue } from 'recoil';
import { RecoilAtomKey } from '../../recoilConstantKey';

const supplierListAtom = atom({
  key: RecoilAtomKey.supplierListKey,
  default: [],
});
const userListAtom = atom({
  key: RecoilAtomKey.userListkey,
  default: { users: [] },
});

const messageListAtom = atom({
  key: RecoilAtomKey.messageListKey,
  default: {
    messages: [],
    filters: { page: 1, phone_number: '', bot_number: '', chat_type: '', intervened_by: '' },
  },
});

const showMobileViewAtom = atom({
  key: RecoilAtomKey.showMobileViewKey,
  default: { userList: true, messageBox: false, userProfile: false },
});

const interveneFilterAtom = atom({
  key: RecoilAtomKey.interveneFilterKey,
  default: {
    userType: 'active',
    search: '',
    typeOfEntity: '',
    page: 1,
    date_type: '',
    start_date: '',
    end_date: '',
    channelObj: null,
    botNumber: '',
    campaignId: '',
    resetUserList: true,
  },
});
const userDetailAtom = atom({
  key: RecoilAtomKey.userDetailKey,
  default: {},
});
const userJourneyAtom = atom({
  key: RecoilAtomKey.userJourneyKey,
  default: [],
});
const callersListAtom = atom({
  key: RecoilAtomKey.callersListKey,
  default: [],
});
const dialerAgentListAtom = atom({
  key: RecoilAtomKey.dialerAgentListKey,
  default: {},
});

const addPocFormAtom = atom({
  key: RecoilAtomKey.addPocFormKey,
  default: [{ contact_type: '', email: '', mobile: '', name: '' }],
});

const channelListAtom = atom({
  key: RecoilAtomKey.channelListKey,
  default: [],
});

const userSupplierListAtom = atom({
  key: RecoilAtomKey.userSupplierListKey,
  default: [],
});

const phoneNumberForFormAtom = atom({
  key: RecoilAtomKey.phoneNumberForFormKey,
  default: '',
});

const chatCountsAtom = atom({
  key: 'chatCountsAtom',
  default: {
    intervene: 0,
    min_15: 0,
    hrs_24: 0,
    history: 0,
    total: 0,
  },
});

export {
  userListAtom,
  messageListAtom,
  showMobileViewAtom,
  interveneFilterAtom,
  userDetailAtom,
  userJourneyAtom,
  callersListAtom,
  dialerAgentListAtom,
  addPocFormAtom,
  supplierListAtom,
  channelListAtom,
  userSupplierListAtom,
  phoneNumberForFormAtom,
  chatCountsAtom,
};
